import React from 'react'
import { humanize } from '../../../../../../../../itrust_common/components/HelperFunctions'
import { useDispatch } from 'react-redux'
import { visionInsuranceClaimFormEdit } from '../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'

export default function ClaimFormOverview(props) {
  const { claimFormTemplate, visionInsuranceClaimForm } = props
  const dispatch = useDispatch()

  if (!claimFormTemplate || !claimFormTemplate.config) return null

  const { config } = claimFormTemplate

  const getFieldDisplayValue = (field, sectionName) => {

    const sectionData = visionInsuranceClaimForm?.[sectionName]
    if (!sectionData) return ''

    const val = sectionData[field.label]
    if (val === undefined || val === null || val === '') return ''

    if (field.type === 'dropdown') {

      const valueToFind = (val && typeof val === 'object' && 'value' in val) ? val.value : val
      const option = field.options?.find(opt => opt.value === valueToFind)
      return option ? option.label : valueToFind

    }

    if (field.type === 'checkbox') {
      return val ? 'Yes' : 'No'
    }

    if (val && typeof val === 'object' && 'value' in val) {
      return val.value
    }

    if (val && typeof val === 'object') {
      if ('label' in val) return val.label
      if ('value' in val) return val.value

      return JSON.stringify(val)
    }

    return String(val)
  }

  return (
    <div className='mt-7'>
      <div className='bg-white p-6 border rounded'>
        <div className='d-flex justify-content-between align-items-center mb-6 pb-4 border-bottom'>
          <h3 className="mb-0 text-primary">Eyefinity Insurance Claim Form Overview</h3>
          <button className='btn btn-primary' onClick={() => dispatch(visionInsuranceClaimFormEdit({ formView: 'form', activeTab: 'first', activeModule: '' }))}>Edit Claim Form</button>
        </div>

        {/* {Object.keys(config).map(sectionName => {
          const fields = config[sectionName]
          if (!fields || fields.length === 0) return null

          const hasData = fields.some(field => {
            const displayVal = getFieldDisplayValue(field, sectionName)
            return displayVal !== '' && displayVal !== 'No'
          })

          if (!hasData) return null

          return (
            <div key={sectionName} className='mb-6 pb-6 border-bottom last-border-0'>
              <h5 className='mb-4 text-primary font-weight-bold'>{humanize(sectionName)}</h5>
              <div className='row'>
                {fields.map(field => {
                  const displayVal = getFieldDisplayValue(field, sectionName)
                  if (displayVal === '' || displayVal === 'No') return null

                  return (
                    <div className='col-md-3 col-sm-6 mt-4' key={field.label}>
                      <h6 className='mb-2 text-dark font-size-sm font-weight-bold'>{humanize(field.label)}</h6>
                      <p className='mb-0 text-muted text-break'>
                        {displayVal}</p>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })} */}
      </div>
    </div>
  )
}
